import { OnInit, Input, Output, EventEmitter, Injector, Component } from '@angular/core';

import { IBitfBreadcrumb, IBitfBreadcrumbEvent } from '@interfaces';
import { StoreService } from '@services';
@Component({
  selector: 'bitf-breadcrumbs',
  template: '',
})
export class BitfBreadcrumbsComponent implements OnInit {
  @Input() breadcrumbs: IBitfBreadcrumb[];
  @Output() breadcrumbClick = new EventEmitter<IBitfBreadcrumbEvent>();

  storeService: StoreService;
  constructor(public injector: Injector) {}

  ngOnInit() {
    this.storeService = this.injector.get<StoreService>(StoreService);
  }

  onBreadcrumbClick(breadcrumbClicked: IBitfBreadcrumb, i: number) {
    const newBreadcrumbs = [...this.breadcrumbs];
    newBreadcrumbs.length = i + 1;
    this.breadcrumbClick.emit({ breadcrumbClicked, newBreadcrumbs });
  }

  goToRoot() {
    this.breadcrumbClick.emit({ breadcrumbClicked: undefined, newBreadcrumbs: [] });
  }
}
